import { render, staticRenderFns } from "./renewReqForm.vue?vue&type=template&id=00447372&"
import script from "./renewReqForm.vue?vue&type=script&lang=js&"
export * from "./renewReqForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports